import React from "react";
import { graphql } from "gatsby";
import Layout from "../../components/Layout";
import WithI18next from "../../components/WithI18next";
import ZLaunchLayout from "../../layouts/ZLaunchLayout";

const ZLaunchPage = ({ data, lang, t }) => {
  return (
    <Layout
      title={t("zlaunch.seo.title")}
      description={t("zlaunch.seo.description")}
    >
      <ZLaunchLayout data={data} lang={lang} t={t} />
    </Layout>
  );
};

export default WithI18next()(ZLaunchPage);

export const query = graphql`
  query ($wpLocale: String!, $wpGlobalConfig: String!) {
    heroContent: allWpHeroSectionItem(
      filter: {
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { eq: $wpGlobalConfig } }
        acfHeroSections: { hsPage: { eq: "zlaunch" } }
      }
    ) {
      edges {
        node {
          acfHeroSections {
            hsMainHeading
            hsMainText
            hsButtonText
            hsButtonLink
          }
        }
      }
    }

    aboutZlaunch: allWpPartialItem(
      filter: {
        acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
        acfPartials: { pPartialId: { eq: "about-zlaunch" } }
        language: { locale: { eq: $wpLocale } }
      }
      sort: { order: ASC, fields: date }
    ) {
      edges {
        node {
          acfPartials {
            pHeading
            pContent
          }
        }
      }
    }

    imageScreenshot: file(
      relativePath: { eq: "images/zlaunch-screenshot.png" }
    ) {
      publicURL
    }

    projectApplication: allWpPartialItem(
      filter: {
        acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
        acfPartials: { pPartialId: { eq: "project-application" } }
        language: { locale: { eq: $wpLocale } }
      }
      sort: { order: ASC, fields: date }
    ) {
      edges {
        node {
          acfPartials {
            pHeading
            pContent
            pIcon {
              localFile {
                publicURL
              }
            }
            pButtonText
            pButtonUrl
          }
        }
      }
    }

    whyZlaunchContent: allWpPartialItem(
      filter: {
        acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
        acfPartials: { pPartialId: { eq: "why-zlaunch" } }
        language: { locale: { eq: $wpLocale } }
      }
      sort: { order: ASC, fields: date }
    ) {
      edges {
        node {
          acfPartials {
            pHeading
            pCssClasses
            pContent
            pIcon {
              localFile {
                publicURL
              }
            }
          }
        }
      }
    }

    zlaunchIcon: file(relativePath: { eq: "images/menus/icons/zlaunch.svg" }) {
      publicURL
    }

    faqContent: allWpSupportCenterItem(
      filter: {
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
        categories: { nodes: { elemMatch: { slug: { eq: "zlaunch" } } } }
      }
      sort: { order: DESC, fields: date }
    ) {
      edges {
        node {
          title
          content
        }
      }
    }

    allWpNewCoinInfoItem(
      filter: {
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { in: [$wpGlobalConfig] } }
        categories: { nodes: { elemMatch: { slug: { eq: "zlaunch-coin" } } } }
      }
    ) {
      edges {
        node {
          slug
          excerpt
          acfCoinInfo {
            ciTickerSymbol
            ciIcon {
              localFile {
                publicURL
              }
            }
          }
        }
      }
    }
  }
`;
